import { useTranslation } from 'react-i18next';
import {
  MAX_CRYPTO_WITHDRAWAL_LIMIT,
  PaymentMethod,
  UNRESTRICTED_WITHDRAWAL_CRYPTO_COUNTRIES,
} from '@monorepo/types';
import { useStore } from '../../../helpers/use-store';
import { formatter } from '../utils';

interface UseCryptoWithdrawalLimitProps {
  maxWithdrawal: number;
  selectedPaymentOption?: PaymentMethod;
}

export const useCryptoWithdrawalLimit = ({
  maxWithdrawal,
  selectedPaymentOption,
}: UseCryptoWithdrawalLimitProps) => {
  const { t } = useTranslation(['withdrawFunds']);
  const {
    dataStore: { userStore },
  } = useStore();

  const isCryptoPaymentSelected =
    selectedPaymentOption === PaymentMethod.Crypto;

  const isUnrestrictedCountry =
    UNRESTRICTED_WITHDRAWAL_CRYPTO_COUNTRIES.includes(userStore.getCountry());

  const isAboveCryptoWithdrawalLimit =
    isCryptoPaymentSelected &&
    !isUnrestrictedCountry &&
    maxWithdrawal > MAX_CRYPTO_WITHDRAWAL_LIMIT;

  const maxWithdrawalLimit = isAboveCryptoWithdrawalLimit
    ? MAX_CRYPTO_WITHDRAWAL_LIMIT
    : maxWithdrawal;

  const maximumWithdrawalMessage = t(
    `withdrawFunds:maximum_withdrawal${isAboveCryptoWithdrawalLimit ? '_crypto' : ''}`,
    {
      maxWithdrawal: formatter(maxWithdrawalLimit),
    },
  );

  return {
    isCryptoPaymentSelected,
    isAboveCryptoWithdrawalLimit,
    maxWithdrawalLimit,
    maximumWithdrawalMessage,
    isUnrestrictedCountry,
  };
};
